import './bootstrap'

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import App from './components/App.vue'
import router from './router'
import store from './store'

Vue.use(VueI18n)

const el = document.body.appendChild(document.createElement('app'))

/* eslint-disable no-new */
new Vue({
  el,
  router,
  store,
  render: h => h(App)
})
